import {
  fetchGetOpenBankingShareableLinkHandler,
  GetOpenBankingShareableLinkHandlerResponse,
} from '@iwoca/lapi-client/edge';
import { LapiError } from '@iwoca/lapi-client/lendingAPI';
import { useQuery } from '@tanstack/react-query';

export function useGetOpenBankingShareableLink({ token }: { token?: string }) {
  const {
    data: response,
    isLoading,
    isError,
    error,
  } = useQuery<GetOpenBankingShareableLinkHandlerResponse, LapiError>({
    queryKey: ['getOpeningBankingShareableLink', token],
    queryFn: () => fetchGetOpenBankingShareableLinkHandler({ token: token! }),
    enabled: Boolean(token),
  });

  return { openBankingLink: response?.data, isLoading, isError, error };
}
